<template>
  <div id="app">
    <router-view />

  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  name: 'App',
  methods: {
    ...mapActions({
      getUserAuthority: 'user/getUserAuthority'
    })
  },
  async mounted() {
    
    await this.getUserAuthority()
  }
}
</script>

<style lang="less">
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
}
</style>
